import { Component, OnInit, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { CalendarUtilsService } from 'src/app/services/calendar-utils.service';
import { eventTypesIcons } from 'src/app/models/events.mockup';
import { EventDetails } from 'src/app/models/events.model';
import * as moment from 'moment/moment';
import { EventsService } from 'src/app/services/events.service';
import { AgendaUtilsService } from 'src/app/services/agenda-utils.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentsCommunicationService } from 'src/app/services/components-communication.service';

@Component({
  selector: 'transflo-flagged-agenda',
  templateUrl: './flagged-agenda.component.html',
  styleUrls: ['./flagged-agenda.component.scss']
})
export class FlaggedAgendaComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  loadEvents = true;
  errorNoEvents = false;
  paginationShouldLoad = true;
  currentDay: any;
  eventslist = [];
  eventTypesIconClasses = eventTypesIcons;
  calendarView: string;
  paginationHeader: any;
  @Output() openUpdateEventModal = new EventEmitter();
  documentMetadata: any[] = [];
  documentName: string = "";
  showPopup: boolean = false;
  eventId: number;
  refreshSubscription: Subscription;
  constructor(
    private calendarUtils: CalendarUtilsService,
    private eventsService: EventsService,
    private agendaUtils: AgendaUtilsService,
    private communicationService: ComponentsCommunicationService
  ) { }

  ngOnInit(): void {
    this.refreshSubscription = this.communicationService.refresh$.subscribe(() => {
      this.refreshAgenda();
    });

    this.refreshAgenda();
  }

  refreshAgenda(): void {
    this.populateAgenda([]);
    this.calendarUtils.calendarChangeEvents
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => { this.populateAgenda(value); });
    this.calendarUtils.calendarDayClicked
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => { this.populateAgenda(value); });
    this.calendarUtils.calendarViewSubject
      .subscribe(value => this.calendarView = value);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get currentDayFormatted() { return moment(this.currentDay).format('MMMM DD'); }
  get toDayFormatted() { return moment(this.currentDay).add(10, 'days').format('MMMM DD'); }

  populateAgenda(dayValue: any): void {
    window.scrollTo(0, 0);
    this.currentDay = dayValue;
    this.eventsService.getEvents({
      fromDate: moment(dayValue).format('YYYY-MM-DD'),
      toDate: moment(dayValue).add(10, 'days').format('YYYY-MM-DD'),
      isFlagged: true
    }).subscribe(result => {
      this.loadEvents = false;
      this.errorNoEvents = result.body.length === 0 ? true : false;
      this.paginationHeader = JSON.parse(result.headers.get('x-pagination'));
      this.eventslist = this.agendaUtils.constructEventsList(result.body);
      this.agendaUtils.setActiveEvent(this.eventslist);
      this.agendaUtils.setTimeUntilNextEvent(this.eventslist);
    });
  }

  editEvent($event: EventDetails): void {
    this.openUpdateEventModal.emit({ event: $event, shouldOpenModal: true });
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
      if (this.paginationHeader && this.paginationHeader.HasNextPage && this.paginationShouldLoad) {
        this.paginationShouldLoad = false;
        this.eventsService.getEvents({
          fromDate: moment(this.currentDay).format('YYYY-MM-DD'),
          toDate: moment(this.currentDay).add(10, 'days').format('YYYY-MM-DD'),
          pageNumber: this.paginationHeader.CurrentPage + 1,
          isFlagged: true
        }).subscribe(result => {
          this.paginationHeader = JSON.parse(result.headers.get('x-pagination'));
          this.eventslist = [...this.eventslist, ...this.agendaUtils.constructEventsList(result.body)];
          this.eventslist = this.agendaUtils.mergeArrayEvents(this.eventslist);
          this.agendaUtils.setActiveEvent(this.eventslist);
          this.agendaUtils.setTimeUntilNextEvent(this.eventslist);
          this.paginationShouldLoad = true;
        });
      }
    }
  }

  onCompleteEvent(event: EventDetails): void {
    this.eventsService.getEvent(event.Id).subscribe(
      (response) => {
        if (response && response.body && response.body.Action && response.body.Action.Document &&
          response.body.Action.Document.MetaData && response.body.Action.Document.MetaData.length > 0) {
          this.documentMetadata = response.body.Action.Document.MetaData;
          this.documentName = response.body.Action.Document.Name;
          this.showPopup = true;
          this.eventId = event.Id;
        }
        else if (response && response.body && response.body.Action && response.body.Action.Document &&
          response.body.Action.Document.MetaData && response.body.Action.Document.MetaData.length == 0) {
            const fleetId = localStorage.getItem('fleetId');
            const token = localStorage.getItem('token');
            const appScheme = 'transflomobileplus';
            let deepLinkUrl = `${appScheme}://scan?recipientid=${fleetId}&return=confnumber&fleetId=${fleetId}&token=${token}&eventId=${this.eventId}`;
  
            window.location.href = deepLinkUrl;
        }
        else {
          console.log("No documents found for this event.");

          this.eventsService.CompleteEvent(event.Id).subscribe(resp => {
            if (resp && resp.status === 204) {
              console.log("Formatted Response:", JSON.stringify(resp.body, null, 2));
            }
            this.refreshAgenda();
            this.communicationService.triggerRefresh();
          });
        }
      },
      (error) => {
        console.error("Error fetching event data", error);
      }
    );
  }

  onClosePopup(): void {
    this.showPopup = false;
  }

  onSubmitForm(formData: any): void {
    console.log("Form submitted with data:", formData);
  }
}
